import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/*import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'*/

// 测试
// axios.defaults.baseURL = 'http://localhost:7001';

// 生产
axios.defaults.baseURL = 'http://47.116.182.38:7001';

// 测试 - 使用代理避免CORS问题
// axios.defaults.baseURL = 'http://localhost:7002';

// 生产
// axios.defaults.baseURL = 'http://47.116.182.38:7002';

// 添加请求拦截器，自动添加 token
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器，处理认证错误
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Token 无效或过期，清除本地存储并跳转到登录页
      localStorage.removeItem('token');
      localStorage.removeItem('userRole');
      localStorage.removeItem('username');
      localStorage.removeItem('customerInfo');
      router.push('/customer/login');
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false
Vue.use(ElementUI)

// 创建Vue实例
const app = new Vue({
  router,
  store,
  render: h => h(App)
})

// 在挂载应用之前预加载用户信息
async function initializeApp() {
  // 如果有token，预加载用户信息
  if (localStorage.getItem('token')) {
    try {
      await store.dispatch('fetchUserInfo')
    } catch (error) {
      console.error('预加载用户信息失败:', error)
    }
  }
  
  // 挂载应用
  app.$mount('#app')
}

initializeApp()
